module.exports = __webpack_public_path__ + "static/media/social-dribble.0c731451.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-dribble.svg
// module id = 105
// module chunks = 0